import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { UserTaskHistory } from './user-task-history';
export { UserTaskHistory };
import { userTaskHistorySchema } from '@schemas/business-objects/user-task-history';
import { UserTaskFormGroup } from './user-task-form-group';

export class UserTaskHistoryFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    eventType: SchemaFormControl;
    data: SchemaFormControl;
    timestamp: SchemaFormControl;
    userTaskId: SchemaFormControl;
    userTask: UserTaskFormGroup;
  };

  declare value: Partial<UserTaskHistory>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(userTaskHistorySchema, UserTaskHistory, data, options);
  }

  get object(): UserTaskHistory {
    return new UserTaskHistory(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'userTask':
        return new UserTaskFormGroup();
      default:
        return undefined;
    }
  }
}

export class UserTaskHistoryFormArray extends PersistedFormArray {
  readonly entityName = 'UserTaskHistory' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(userTaskHistorySchema, UserTaskHistory, options);
  }

  protected override createItemGroup() {
    return new UserTaskHistoryFormGroup();
  }

  get array(): UserTaskHistory[] {
    return this.controls.map((group: UserTaskHistoryFormGroup) => group.object);
  }
}

export class UserTaskHistoryPersistedArray extends PersistedArray<UserTaskHistory> {
  readonly entityName = 'UserTaskHistory' as const;

  constructor(options?: PersistedArrayOptions) {
    super(UserTaskHistory, options);
  }
}
